import React from 'react';
import styled from 'styled-components';
import { FiMenu } from 'react-icons/fi';

const MenuIconWrapper = styled.div`
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1000;
  background: var(--bg-card);
  padding: 0.5rem;
  border-radius: 0.4rem;
  cursor: pointer;
  border: 1px solid var(--border-color);

  svg {
    color: var(--btn-primary);
    font-size: 1.8rem;
  }

  &:hover {
    background: var(--btn-primary);
    svg {
      color: white;
    }
  }
`;

export default function MenuIcon({ onClick, ...props }) {
  return (
    <MenuIconWrapper onClick={onClick} {...props}>
      <FiMenu />
    </MenuIconWrapper>
  );
}
